import React, { memo } from "react";
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';


const Email = (props)=>{
  const { 
    item,
    className,
    validationForms,
    fieldObj
  } = props;
  const attr = formFieldsAttributes(
    {...item,className:className
  },validationForms);
  
  return (
    <FormBlocks {...props}  attr={attr}>
        <input 
          value={attr.value}
          type="text"
          onBlur={e=> props.onBlurHandlerAction(fieldObj,e)}
          onChange={e => props.onChangeInputAction(fieldObj,e)}
          {...attr.fieldAttributes}
        />
    </FormBlocks>
  );
}


Email.defaultProps = {
  className:'form-control'
};

const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item.selectedValue===nextProps.item.selectedValue && prevProps.validationForms===nextProps.validationForms && prevProps.item.access_mode===nextProps.item.access_mode && prevProps.item.required===nextProps.item.required){
    return true;
  }
}

export default memo(Email,isDiffProps);
